import React from 'react';
import {UncontrolledTooltip} from "reactstrap";
import { Glob as G } from "../../libs/Glob.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import CopIcon from "../../media/images/CopIcon.mjs";
import UserOffIcon from "../../media/images/UserOffIcon.mjs";
import "./UserFlags.css";

const UserFlags = class extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid('UserFlags')
	}
	render() {
		const u = this.props.user;
		return(
			<div className={"UserFlags"} key={u.user+'-flags'}>
				{ u.isAdmin ? (
					<span className="userAdmin" id={this.uid+'-admin'}>
							<CopIcon />
							<UncontrolledTooltip target={this.uid+'-admin'}>
								<TextLabel value={"Administrator"} />
							</UncontrolledTooltip>
						</span>
				) : '' }
				{ u.isDisabled ? (
					<span className="userDisabled" id={this.uid + '-disabled'}>
							<UserOffIcon />
							<UncontrolledTooltip target={this.uid+'-disabled'}>
								<TextLabel value={"Disabled user"} />
							</UncontrolledTooltip>
						</span>
				) : ''}
			</div>
		)
	}
}

export default UserFlags;